if (!customElements.get('sr-perks')) {
    customElements.define('sr-perks', class SRPerks extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                slider: '.js-perks-slider'
            }

            this.toogles = this.querySelectorAll(this.selectors.slider);

            this.init();
        }

        init() {
            $(this.toogles).slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 860,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 620,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    });
}